// Transaction/billing filter statuses shared between the admin leads filter UI
// and the backend lead query builder (applyBillingFilters). These are the values
// sent as `transaction_status` substates and matched against in SQL.
export enum BillingStatusEnum {
    PENDING = 'pending-charge-billing',
    CHARGED = 'charged-billing',
    REFUNDED = 'refunded-billing',
}
